// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// There is no `admin/findings` route and that is not an oversight: a finding
// IS a task, so it is read from the task list filtered by state. The day the
// backend publishes a route of its own, this file is the only place that has
// to learn about it.

export const findingPaths = {
    proposed: () => 'admin/tasks',
    origin:   (id) => `admin/tasks/${id}`,
};
